module.exports = __webpack_public_path__ + "4daac744f553b5f8699b367160b1ae7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/podzimni-detsky-tabor-3.jpg
// module id = 1198
// module chunks = 0